module.exports = __webpack_public_path__ + "img/title02_solgan_m.de0e701b.png";